export default "__VITE_ASSET__CcHGosZM__"